export const GET_ALL_CONDITIONS = "GET_ALL_CONDITIONS";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_CONDITIONS = "START_LOADING_CONDITIONS";
export const STOP_LOADING_CONDITIONS = "STOP_LOADING_CONDITIONS";
export const ERROR_LOADING_CONDITIONS = "ERROR_LOADING_CONDITIONS";